<div class="w-100">
  <div class="header-info">
    <h3>Client Venues</h3>
  </div>
  <div class="list-container" *ngIf="venues.length; else noVenues">
    <div class="list-item" *ngFor="let venue of venues">
      <strong>
        <img class="venue-logo" *ngIf="venue.venue_image" [src]="venue.venue_image" alt="{{ venue.name }}" />
        <a class="venue-link" *ngIf="venue.kt_venue_id" [routerLink]="['/venues', venue.kt_venue_id, 'details']">{{ venue.name }}</a>
        <span *ngIf="!venue.kt_venue_id">{{ venue.name }}</span>
         <!-- <span>{{ venue.name }}</span> -->
      </strong>
      <p>
        {{ venue.agreements ? venue.agreements.length : 0 }} active agreement{{
        venue.agreements && venue.agreements.length > 1 ? "s" : ""
        }}
      </p>
      <span class="spacer"></span>
    </div>
  </div>
</div>

<ng-template #noVenues>
  <div class="center-text p-20">
    No Venues Found
  </div>
</ng-template>
